import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './shared/footer/footer.component';
import { PaymentComponent } from './AppointmentPayment/payment/payment.component';
import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./blog-news/blog-news.module').then(m => m.BlogNewsModule)
  },
  {
    path: '',
    loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: '',
    loadChildren: () => import('./treatments/treatments.module').then(m => m.TreatmentsModule)
  },
  {
    path: '',
    loadChildren: () => import('./Static/static.module').then(m => m.StaticModule)
  },
  {
    path: '',
    loadChildren: () => import('./Authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: '',
    loadChildren: () => import('./Forms/so-forms.module').then(m => m.SoFormsModule)
  },
  {
    path: '',
    loadChildren: () => import('./membership/memberships.module').then(m => m.MembershipsModule)
  },
  {
    path: '',
    loadChildren: () => import('./refer/refer.module').then(m => m.ReferModule)
  },
  {
    path: '',
    loadChildren: () => import('./Services/services.module').then(m => m.ServicesModule)
  },
 
  {
    path: '',
    component: HomeComponent,
    data:{
      Title:'Home',
      Text:'Home Page'
    }
  },
  {
    path: 'Contact Us',
    component: FooterComponent
  },
  {
    path: 'payment',
    component: PaymentComponent
  },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollOffset: [0, 0], scrollPositionRestoration: 'enabled' })], //,{scrollOffset: [0, 0], scrollPositionRestoration: 'top' }
  providers: [DatePipe],
  exports: [RouterModule]
})
export class AppRoutingModule { }
